import { render, staticRenderFns } from "./Werke.vue?vue&type=template&id=ea605b68&"
import script from "./Werke.vue?vue&type=script&lang=js&"
export * from "./Werke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports